import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import SearchPaging from "./../factories/search-paging";
import TabPage from "./../factories/tab-page";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabViewModel from "./../factories/tab-controller";
import "./../bindings/bao-tabs";
import "./../bindings/bao-toolbar2";
import "./../bindings/bao-upload";
import AppTabController from "../services/app-tab-controller";
import ItemAuditDialog from "../factories/base-audit-dialog";

function ConfigurationItemTypeTabTabViewModel(tabPage, parent) {
    var self = this;
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageTypeTab = Bao.Session.GetMessage("msgDeleteConfigurationItemTypeTab");
    self.Bao = Bao;
    self.ConfigurationItemType = parent;
    self.TypeTabCollection = ko.observableArray([]);
    self.ShowConfigurationItemTypeTabDialog = function () { };
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItemTypeTab":
                self.ShowConfigurationItemTypeTabDialog(parent.ConfigurationItemTypeId(), null);
                break;
            case "DeleteConfigurationItemTypeTab":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageTypeTab, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result == true) {
                        self.DeleteConfigurationItemTypeTab(parent.ConfigurationItemTypeId(), self.SelectedRow().ConfigurationItemTypeTabId);
                    }
                });
                break;
            case "MoveUpConfigurationItemTypeTab":
                self.MoveUpConfigurationItemTab(parent.ConfigurationItemTypeId(), self.SelectedRow().ConfigurationItemTypeTabId);
                break;
            case "MoveDownConfigurationItemTypeTab":
                self.MoveDownConfigurationItemTab(parent.ConfigurationItemTypeId(), self.SelectedRow().ConfigurationItemTypeTabId);
                break;
        }
    };
    self.SelectedRow = ko.observable({});
    self.SelectedRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "DeleteConfigurationItemTypeTab") {
                button.Enabled(self.SelectedRow() != null);
            }
            if (button.ActionKey() == "MoveUpConfigurationItemTypeTab") {
                button.Enabled(self.SelectedRow() != null);
            }
            if (button.ActionKey() == "MoveDownConfigurationItemTypeTab") {
                button.Enabled(self.SelectedRow() != null);
            }
        });
    };
    self.ToolbarButtons = ko.observableArray();
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ConfigurationItemTab = ko.observable();
    self.ConfigurationItemTab.subscribe(function () {
        self.AddConfigurationItemTypeTab(self.ConfigurationItemTab().ConfigurationItemTabId, parent.ConfigurationItemTypeId());
    });
    self.SelectedConfigurationItemTabId = ko.observable();
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.Refresh();
    });
    self.PageSize = ko.observable(20);
    self.PageSize.subscribe(function () {
        if (self.PageIndex() > 0) {
            self.PageIndex(0);
        }
        else {
            self.Refresh();
        }
    });
    self.TotalRows = ko.observable(0);
    self.AddConfigurationItemTypeTab = function (configurationItemTabId, configurationItemTypeId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/AddConfigurationItemTypeTab", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTabId: configurationItemTabId,
            configurationItemTypeId: configurationItemTypeId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.DeleteConfigurationItemTypeTab = function (configurationItemTypeId, configurationItemTypeTabId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/DeleteConfigurationItemTypeTab", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: configurationItemTypeId,
            configurationItemTypeTabId: configurationItemTypeTabId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.MoveUpConfigurationItemTab = function (configurationItemTypeId, configurationItemTypeTabId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/MoveUpConfigurationItemTypeTab", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: configurationItemTypeId,
            configurationItemTypeTabId: configurationItemTypeTabId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.MoveDownConfigurationItemTab = function (configurationItemTypeId, configurationItemTypeTabId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/MoveDownConfigurationItemTypeTab", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: configurationItemTypeId,
            configurationItemTypeTabId: configurationItemTypeTabId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.Refresh();
        });
    };
    self.Refresh = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/GetConfigurationItemTypeTabCollection", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: parent.ConfigurationItemTypeId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: null
        }), function (searchResult) {
            self.SelectedRow(null);
            self.TotalRows(0);
            self.TypeTabCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.TypeTabCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
                self.ToggleToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
}
;
function ConfigurationItemTypeStatusViewModel(tabPage, parent) {
    var self = this;
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageStatusType = Bao.Session.GetMessage("msgDeleteConfigurationItemStatusType");
    self.Bao = Bao;
    self.ConfigurationItemType = parent;
    self.StatusCollection = ko.observableArray([]);
    self.ShowConfigurationItemTypeStatusDialog = function () { };
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItemTypeStatus":
                self.ShowConfigurationItemTypeStatusDialog(parent.ConfigurationItemTypeId(), null);
                break;
            case "DeleteConfigurationItemTypeStatus":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageStatusType, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteConfigurationItemStatusType(parent.ConfigurationItemTypeId(), self.SelectedStatusRow().ConfigurationItemStatusTypeId);
                    }
                });
                break;
        }
    };
    self.StatusSorting = ko.observableArray();
    self.StatusSorting.subscribe(function () {
        self.RefreshStatusGrid();
    });
    self.SelectedStatusRow = ko.observable({});
    self.SelectedStatusRow.subscribe(function () {
        self.ToggleStatusToolbarButtons();
    });
    self.ToggleStatusToolbarButtons = function () {
        ko.utils.arrayForEach(self.StatusToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "DeleteConfigurationItemTypeStatus") {
                button.Enabled(self.SelectedStatusRow() != null);
            }
        });
    };
    self.StatusToolbarButtons = ko.observableArray();
    self.StatusToolbarButtons.subscribe(function () {
        self.ToggleStatusToolbarButtons();
    });
    self.SelectedStatus = ko.observable();
    self.SelectedStatus.subscribe(function () {
        self.AddConfigurationItemStatusType(self.SelectedStatusId(), parent.ConfigurationItemTypeId());
    });
    self.SelectedStatusId = ko.observable();
    self.StatusPageIndex = ko.observable(0);
    self.StatusPageIndex.subscribe(function () {
        self.RefreshStatusGrid();
    });
    self.StatusPageSize = ko.observable(20);
    self.StatusPageSize.subscribe(function () {
        if (self.StatusPageIndex() > 0) {
            self.StatusPageIndex(0);
        }
        else {
            self.RefreshStatusGrid();
        }
    });
    self.StatusTotalRows = ko.observable(0);
    self.AddConfigurationItemStatusType = function (configurationItemStatusId, configurationItemTypeId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/AddConfigurationItemStatusType", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemStatusId: configurationItemStatusId,
            configurationItemTypeId: configurationItemTypeId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshStatusGrid();
        });
    };
    self.DeleteConfigurationItemStatusType = function (configurationItemTypeId, configurationItemStatusTypeId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/DeleteConfigurationItemStatusType", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: configurationItemTypeId,
            configurationItemStatusTypeId: configurationItemStatusTypeId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshStatusGrid();
        });
    };
    self.ShowConfigurationItemTypeStatusDialog = function () { };
    self.RefreshStatusGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/GetConfigurationItemStatusTypeCollection", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: parent.ConfigurationItemTypeId(),
            pageIndex: self.StatusPageIndex(),
            pageSize: self.StatusPageSize(),
            sorting: self.StatusSorting()
        }), function (searchResult) {
            self.SelectedStatusRow(null);
            self.StatusTotalRows(0);
            self.StatusCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.StatusCollection(searchResult.Models);
                self.StatusTotalRows(searchResult.TotalRows);
                self.ToggleStatusToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
    self.Focus = function () { };
    self.Refresh = function () {
        return self.RefreshStatusGrid();
    };
}
;
function ConfigurationItemTypeManufacturerViewModel(tabPage, parent) {
    var self = this;
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageTypeManufacturer = Bao.Session.GetMessage("msgDeleteConfigurationItemTypeManufacturer");
    var _deleteMessageTypeManufacturerType = Bao.Session.GetMessage("msgDeleteConfigurationItemTypeManufacturerType");
    self.manufacturerTabTitle = ko.observable(Bao.Session.GetMessage("msgConfigurationItemTypeManufacturer"));
    self.Bao = Bao;
    self.ConfigurationItemType = parent;
    self.ManufacturerSorting = ko.observableArray();
    self.ManufacturerSorting.subscribe(function () {
        self.RefreshManufacturerGrid();
    });
    self.SelectedManufacturerRow = ko.observable({});
    self.SelectedManufacturerRow.subscribe(function () {
        self.ToggleManufacturerToolbarButtons();
        self.ToggleManufacturerTypeToolbarButtons();
        self.RefreshManufacturerTypeGrid();
    });
    self.ToggleManufacturerToolbarButtons = function () {
        ko.utils.arrayForEach(self.ManufacturerToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "DeleteConfigurationItemTypeManufacturer") {
                button.Enabled(self.SelectedManufacturerRow() != null);
            }
        });
    };
    self.SelectedManufacturer = ko.observable();
    self.SelectedManufacturer.subscribe(function () {
        self.AddConfigurationItemTypeManufacturer(self.SelectedManufacturerId(), parent.ConfigurationItemTypeId());
    });
    self.SelectedManufacturerId = ko.observable();
    self.ManufacturerPageIndex = ko.observable(0);
    self.ManufacturerPageIndex.subscribe(function () {
        self.RefreshManufacturerGrid();
    });
    self.ManufacturerPageSize = ko.observable(20);
    self.ManufacturerPageSize.subscribe(function () {
        if (self.ManufacturerPageIndex() > 0) {
            self.ManufacturerPageIndex(0);
        }
        else {
            self.RefreshManufacturerGrid();
        }
    });
    self.ManufacturerTotalRows = ko.observable(0);
    self.ManufacturerToolbarButtons = ko.observableArray();
    self.ManufacturerToolbarButtons.subscribe(function () {
        self.ToggleManufacturerToolbarButtons();
    });
    self.toolbarManufacturerClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItemTypeManufacturer":
                self.ShowConfigurationItemTypeManufacturerDialog(parent.ConfigurationItemTypeId(), null);
                break;
            case "DeleteConfigurationItemTypeManufacturer":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageTypeManufacturer, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteConfigurationItemTypeManufacturer(parent.ConfigurationItemTypeId(), self.SelectedManufacturerRow().ConfigurationItemTypeManufacturerId);
                    }
                });
                break;
            case "ConfigurationItemTypeManufacturerAuditTrail":
                self.ShowConfigurationItemTypeManufacturerAuditTrail(parent.ConfigurationItemTypeId(), self.SelectedManufacturerRow());
                break;
        }
    };
    self.ShowConfigurationItemTypeManufacturerAuditTrail = function(configurationItemTypeId, selectedManufacturerRow){
        let getCollectionUrl = "ConfigurationItemType/ShowConfigurationItemTypeManufacturerAuditTrail";
        let isOverview = true;
        
        let auditDialog = new ItemAuditDialog(configurationItemTypeId, ko.unwrap(self.manufacturerTabTitle()), tabPage, getCollectionUrl, isOverview);
        auditDialog.Open();
    };
    self.AddConfigurationItemTypeManufacturer = function (manufacturerId, configurationItemTypeId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/AddConfigurationItemTypeManufacturer", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            manufacturerId: manufacturerId,
            configurationItemTypeId: configurationItemTypeId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshManufacturerGrid();
        });
    };
    self.DeleteConfigurationItemTypeManufacturer = function (configurationItemTypeId, configurationItemTypeManufacturerId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/DeleteConfigurationItemTypeManufacturer", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: configurationItemTypeId,
            configurationItemTypeManufacturerId: configurationItemTypeManufacturerId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshManufacturerGrid();
        });
    };
    self.ShowConfigurationItemTypeManufacturerDialog = function () { };
    self.ManufacturerCollection = ko.observableArray();
    self.RefreshManufacturerGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/GetConfigurationItemTypeManufacturerCollection", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: parent.ConfigurationItemTypeId(),
            pageIndex: self.ManufacturerPageIndex(),
            pageSize: self.ManufacturerPageSize(),
            sorting: self.ManufacturerSorting()
        }), function (searchResult) {
            self.SelectedManufacturerRow(null);
            self.ManufacturerTotalRows(0);
            self.ManufacturerCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.ManufacturerCollection(searchResult.Models);
                self.ManufacturerTotalRows(searchResult.TotalRows);
                self.ToggleManufacturerToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
    self.ManufacturerTypeCollection = ko.observableArray([]);
    self.ManufacturerTypeSorting = ko.observableArray();
    self.ManufacturerTypeSorting.subscribe(function () {
        self.RefreshManufacturerTypeGrid();
    });
    self.SelectedManufacturerTypeRow = ko.observable({});
    self.SelectedManufacturerTypeRow.subscribe(function () {
        self.ToggleManufacturerTypeToolbarButtons();
    });
    self.ToggleManufacturerTypeToolbarButtons = function () {
        ko.utils.arrayForEach(self.ManufacturerTypeToolbarButtons(), function (button: any) {
            if (self.SelectedManufacturerRow() == null) {
                button.Enabled(false);
            }
            else {
                if (button.ActionKey() == "DeleteConfigurationItemTypeManufacturerType" || button.ActionKey() == "EditConfigurationItemTypeManufacturerType") {
                    button.Enabled(self.SelectedManufacturerTypeRow() != null);
                }
                else {
                    button.Enabled(true);
                }
            }
        });
    };
    self.SelectedManufacturerType = ko.observable();
    self.SelectedManufacturerType.subscribe(function () {
        self.AddConfigurationItemTypeManufacturerType(self.SelectedManufacturerTypeId(), self.SelectedManufacturerId());
    });
    self.SelectedManufacturerTypeId = ko.observable();
    self.ManufacturerTypePageIndex = ko.observable(0);
    self.ManufacturerTypePageIndex.subscribe(function () {
        self.RefreshManufacturerTypeGrid();
    });
    self.ManufacturerTypePageSize = ko.observable(20);
    self.ManufacturerTypePageSize.subscribe(function () {
        if (self.ManufacturerTypePageIndex() > 0) {
            self.ManufacturerTypePageIndex(0);
        }
        else {
            self.RefreshManufacturerTypeGrid();
        }
    });
    self.ManufacturerTypeTotalRows = ko.observable(0);
    self.ManufacturerTypeToolbarButtons = ko.observableArray();
    self.ManufacturerTypeToolbarButtons.subscribe(function () {
        self.ToggleManufacturerTypeToolbarButtons();
    });
    self.toolbarManufacturerTypeClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItemTypeManufacturerType":
                self.ShowConfigurationItemTypeManufacturerTypeDialog(parent.ConfigurationItemTypeId(), self.SelectedManufacturerRow().ConfigurationItemTypeManufacturerId, null);
                break;
            case "EditConfigurationItemTypeManufacturerType":
                self.ShowConfigurationItemTypeManufacturerTypeDialog(parent.ConfigurationItemTypeId(), self.SelectedManufacturerRow().ConfigurationItemTypeManufacturerId, self.SelectedManufacturerTypeRow().ManufacturerTypeId);
                break;
            case "DeleteConfigurationItemTypeManufacturerType":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageTypeManufacturerType, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteConfigurationItemTypeManufacturerType(parent.ConfigurationItemTypeId(), self.SelectedManufacturerRow().ConfigurationItemTypeManufacturerId, self.SelectedManufacturerTypeRow().ManufacturerTypeId);
                    }
                });
                break;
            case "ConfigurationItemTypeManufacturerTypeAuditTrail":
                self.ShowConfigurationItemTypeManufacturerTypeAuditTrail(self.SelectedManufacturerRow().ConfigurationItemTypeManufacturerId, self.SelectedManufacturerTypeRow());
                break;
        }
    };
    self.ShowConfigurationItemTypeManufacturerTypeAuditTrail = function(parentId, selectedItemId){
        let getCollectionUrl = "ConfigurationItemType/ShowConfigurationItemTypeManufacturerTypeAuditTrail";
        let isOverview = true;
        let customFiler = ko.observable<any>({});
        
        if (selectedItemId != null) {
            customFiler = ko.observable<any>({ "ItemId": selectedItemId.OpenData});
            isOverview = false;
        }
        
        let auditDialog = new ItemAuditDialog(parentId, ko.unwrap(self.manufacturerTabTitle()), tabPage, getCollectionUrl, isOverview);
        auditDialog.CustomFilter = customFiler;

        auditDialog.Open();
    };
    self.AddConfigurationItemTypeManufacturerType = function (configurationItemTypeManufacturerTypeModel, configurationItemTypeId) {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemType/AddConfigurationItemTypeManufacturerType", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeManufacturerTypeModel: ko.map.toJS(configurationItemTypeManufacturerTypeModel, false),
            configurationItemTypeId: configurationItemTypeId
        }), function (result) {
            if (result.Result == false) {
                tabPage.IsLoading(false);
                new BaoDialogViewModel(Bao.Session.ApplicationName, result.Message, "info");
            } else {
                parent.TabPage.DirtyFlag(true);
                self.RefreshManufacturerTypeGrid();
            }
        });
    };
    self.EditConfigurationItemTypeManufacturerType = function (item) {
        if (item != null && item.IsInherited != true) {
            self.ShowConfigurationItemSupporterDialog(self.ConfigurationItemType.ConfigurationItemTypeId(), item.ManufacturerTypeId);
        }
    };
    self.DeleteConfigurationItemTypeManufacturerType = function (configurationItemTypeId, configurationItemTypeManufacturerId, manufacturerTypeId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/DeleteConfigurationItemTypeManufacturerType", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: configurationItemTypeId,
            configurationItemTypeManufacturerId: configurationItemTypeManufacturerId,
            manufacturerTypeId: manufacturerTypeId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshManufacturerTypeGrid();
        });
    };
    self.ManufacturerTypeDialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.ManufacturerTypeDialog.Width("450px");
    self.ManufacturerTypeDialog.Buttons([{
        Title: _msgOk,
        Click: function () {
            if (!self.ValidateManufacturerTypeDialog(self.ManufacturerTypeDialog.ViewModel())) {
                return;
            }
            self.AddConfigurationItemTypeManufacturerType(self.ManufacturerTypeDialog.ViewModel(), parent.ConfigurationItemTypeId());
            self.ManufacturerTypeDialog.Close();
        },
        Enabled: ko.observable(true)
    }, {
        Title: _msgCancel,
        Click: function () {
            self.ManufacturerTypeDialog.Close();
        },
        Enabled: ko.observable(true)
    }]);
    self.ShowConfigurationItemTypeManufacturerTypeDialog = function (configurationItemTypeId, configurationItemTypeManufacturerId, manufacturerTypeId) {
        window.baorequire(["ViewModels/Dialogs/ConfigurationItemTypeManufacturerTypeDialog"], function (vm) {
            var dialog = new vm(parent.TabPage, self);
            dialog.Show(configurationItemTypeId, configurationItemTypeManufacturerId, manufacturerTypeId);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.AddConfigurationItemTypeManufacturerType(dialog.DialogViewModel, self.ConfigurationItemType.ConfigurationItemTypeId());
                }
            });
        });
    };
    self.ValidateManufacturerTypeDialog = function (configurationItemTypeManufacturerTypeModel) {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(configurationItemTypeManufacturerTypeModel.Name)) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return false;
        }
        return true;
    };
    self.RefreshManufacturerTypeGrid = function () {
        var def = $.Deferred();
        tabPage.IsLoading(true);
        if (self.SelectedManufacturerRow() != null) {
            Bao.post("ConfigurationItemType/GetConfigurationItemTypeManufacturerTypeCollection", JSON.stringify({
                sessionTabId: parent.TabPage.SessionTabId,
                configurationItemTypeId: parent.ConfigurationItemTypeId(),
                configurationItemTypeManufacturerId: self.SelectedManufacturerRow().ConfigurationItemTypeManufacturerId,
                pageIndex: self.ManufacturerTypePageIndex(),
                pageSize: self.ManufacturerTypePageSize(),
                sorting: self.ManufacturerTypeSorting()
            }), function (searchResult) {
                self.SelectedManufacturerTypeRow(null);
                self.ManufacturerTypeTotalRows(0);
                self.ManufacturerTypeCollection([]);
                if (searchResult != null && searchResult.Models != null) {
                    self.ManufacturerTypeCollection(searchResult.Models);
                    self.ManufacturerTypeTotalRows(searchResult.TotalRows);
                    self.ToggleManufacturerTypeToolbarButtons();
                }
                tabPage.IsLoading(false);
                def.resolve();
            });
        }
        else {
            tabPage.IsLoading(false);
            self.SelectedManufacturerTypeRow(null);
            self.ManufacturerTypeTotalRows(0);
            self.ManufacturerTypeCollection([]);
            def.resolve();
        }
        return def.promise();
    };
    self.Refresh = function () {
        return self.RefreshManufacturerGrid();
    };
}
;
function ConfigurationItemTypeIndicatorViewModel(tabPage, parent) {
    var self = this;
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageTypeIndicator = Bao.Session.GetMessage("msgDeleteConfigurationItemTypeIndicator");
    self.Bao = Bao;
    self.ConfigurationItemType = parent;
    self.SelectedIndicator = ko.observable();
    self.SelectedIndicator.subscribe(function () {
        self.AddConfigurationItemTypeIndicator(self.SelectedIndicatorId(), parent.ConfigurationItemTypeId());
    });
    self.SelectedIndicatorId = ko.observable();
    self.IndicatorPageIndex = ko.observable(0);
    self.IndicatorPageIndex.subscribe(function () {
        self.RefreshIndicatorGrid();
    });
    self.IndicatorPageSize = ko.observable(20);
    self.IndicatorPageSize.subscribe(function () {
        if (self.IndicatorPageIndex() > 0) {
            self.IndicatorPageIndex(0);
        }
        else {
            self.RefreshIndicatorGrid();
        }
    });
    self.IndicatorTotalRows = ko.observable(0);
    self.IndicatorSorting = ko.observableArray();
    self.IndicatorSorting.subscribe(function () {
        self.RefreshIndicatorGrid();
    });
    self.IndicatorCollection = ko.observableArray([]);
    self.SelectedIndicatorRow = ko.observable({});
    self.SelectedIndicatorRow.subscribe(function () {
        self.ToggleIndicatorToolbarButtons();
    });
    self.ToggleIndicatorToolbarButtons = function () {
        ko.utils.arrayForEach(self.IndicatorToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "DeleteConfigurationItemTypeIndicator") {
                button.Enabled(self.SelectedIndicatorRow() != null);
            }
        });
    };
    self.IndicatorToolbarButtons = ko.observableArray();
    self.IndicatorToolbarButtons.subscribe(function () {
        self.ToggleIndicatorToolbarButtons();
    });
    self.toolbarIndicatorClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItemTypeIndicator":
                self.ShowConfigurationItemTypeIndicatorDialog(parent.ConfigurationItemTypeId(), null);
                break;
            case "DeleteConfigurationItemTypeIndicator":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageTypeIndicator, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteConfigurationItemTypeIndicator(parent.ConfigurationItemTypeId(), self.SelectedIndicatorRow().ConfigurationItemTypeIndicatorId);
                    }
                });
                break;
        }
    };
    self.AddConfigurationItemTypeIndicator = function (configurationItemIndicatorId, configurationItemTypeId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/AddConfigurationItemTypeIndicator", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemIndicatorId: configurationItemIndicatorId,
            configurationItemTypeId: configurationItemTypeId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshIndicatorGrid();
            tabPage.IsLoading(false);
        });
    };
    self.DeleteConfigurationItemTypeIndicator = function (configurationItemTypeId, configurationItemTypeIndicatorId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/DeleteConfigurationItemTypeIndicator", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: configurationItemTypeId,
            configurationItemTypeIndicatorId: configurationItemTypeIndicatorId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshIndicatorGrid();
        });
    };
    self.ShowConfigurationItemTypeIndicatorDialog = function () { };
    self.RefreshIndicatorGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/GetConfigurationItemTypeIndicatorCollection", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: parent.ConfigurationItemTypeId(),
            pageIndex: self.IndicatorPageIndex(),
            pageSize: self.IndicatorPageSize(),
            sorting: self.IndicatorSorting()
        }), function (searchResult) {
            self.SelectedIndicatorRow(null);
            self.IndicatorTotalRows(0);
            self.IndicatorCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.IndicatorCollection(searchResult.Models);
                self.IndicatorTotalRows(searchResult.TotalRows);
                self.ToggleIndicatorToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
    self.Refresh = function () {
        return self.RefreshIndicatorGrid();
    };
}

function ConfigurationItemTypeDisplayedFieldViewModel(tabPage, parent) {
    var self = this;
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageDisplayedFieldType = Bao.Session.GetMessage("msgDeleteConfigurationItemDisplayedField");

    self.Bao = Bao;
    self.ConfigurationItemType = parent;
    self.DisplayedFieldCollection = ko.observableArray([]);

    self.ShowConfigurationItemTypeDisplayedFieldDialog = function () {
        //Test
    };

    self.toolbarDisplayFieldsClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItemTypeDisplayedFields":
                self.ShowConfigurationItemTypeDisplayedFieldDialog(parent.ConfigurationItemTypeId(), null);
                break;
            case "DeleteConfigurationItemTypeDisplayedFields":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageDisplayedFieldType, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        if (self.SelectedDisplayedFieldRow() !== null) {
                            self.DeleteConfigurationItemDisplayedFieldType(self.SelectedDisplayedFieldRow().FieldId);
                        }
                    }
                });
                break;
            case "MoveUpConfigurationItemTypeDisplayedFields":
                if (self.SelectedDisplayedFieldRow() !== null) {
                    self.MoveUpConfigurationItemDisplayedField(self.SelectedDisplayedFieldRow().FieldId);
                }
                break;
            case "MoveDownConfigurationItemTypeDisplayedFields":
                if (self.SelectedDisplayedFieldRow() !== null) {
                    self.MoveDownConfigurationItemDisplayedField(self.SelectedDisplayedFieldRow().FieldId);
                }
                break;
        }
    };

    //****
    self.DisplayedFieldSorting = ko.observableArray();
    self.DisplayedFieldSorting.subscribe(function () {
        self.RefreshDisplayedFieldGrid();
    });

    self.SelectedDisplayedFieldRow = ko.observable({});
    self.SelectedDisplayedFieldRow.subscribe(function () {
        self.ToggleDisplayedFieldToolbarButtons();
    });

    self.ToggleDisplayedFieldToolbarButtons = function () {
        ko.utils.arrayForEach(self.DisplayedFieldToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "DeleteConfigurationItemTypeDisplayedFields") {
                button.Enabled(self.SelectedDisplayedFieldRow() !== null);
            }
            if (button.ActionKey() == "MoveUpConfigurationItemTypeDisplayedFields") {
                button.Enabled(self.SelectedDisplayedFieldRow() !== null);
            }
            if (button.ActionKey() == "MoveDownConfigurationItemTypeDisplayedFields") {
                button.Enabled(self.SelectedDisplayedFieldRow() !== null);
            }
        });
    };

    self.DisplayedFieldToolbarButtons = ko.observableArray();
    self.DisplayedFieldToolbarButtons.subscribe(function () {
        self.ToggleDisplayedFieldToolbarButtons();
    });

    self.SelectedDisplayedField = ko.observable();
    self.SelectedDisplayedField.subscribe(function () {
        self.AddConfigurationItemDisplayedFieldType(self.SelectedDisplayedFieldId(), parent.ConfigurationItemTypeId());
    });

    self.SelectedDisplayedFieldId = ko.observable();
    self.DisplayedFieldPageIndex = ko.observable(0);
    self.DisplayedFieldPageIndex.subscribe(function () {
        self.RefreshDisplayedFieldGrid();
    });

    self.DisplayedFieldPageSize = ko.observable(20);
    self.DisplayedFieldPageSize.subscribe(function () {
        if (self.DisplayedFieldPageIndex() > 0) {
            self.DisplayedFieldPageIndex(0);
        } else {
            self.RefreshDisplayedFieldGrid();
        }
    });
    self.DisplayedFieldTotalRows = ko.observable(0);

    self.AddConfigurationItemDisplayedFieldType = function (fieldId, configurationItemTypeId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/AddConfigurationItemTypeDisplayedFields", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            fieldId: fieldId,
            configurationItemTypeId: configurationItemTypeId
        }),
            function () {
                parent.TabPage.DirtyFlag(true);
                self.RefreshDisplayedFieldGrid();
            });
    };

    self.DeleteConfigurationItemDisplayedFieldType = function (fieldId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/DeleteConfigurationItemTypeDisplayedFields", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            fieldId: fieldId
        }),
            function () {
                parent.TabPage.DirtyFlag(true);
                self.RefreshDisplayedFieldGrid();
            });
    };

    self.MoveUpConfigurationItemDisplayedField = function (fieldId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/MoveUpConfigurationItemTypeDisplayedFields", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            fieldId: fieldId
        }),
            function () {
                parent.TabPage.DirtyFlag(true);
                self.Refresh();
            });
    };

    self.MoveDownConfigurationItemDisplayedField = function (fieldId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/MoveDownConfigurationItemTypeDisplayedFields", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            fieldId: fieldId
        }),
            function () {
                parent.TabPage.DirtyFlag(true);
                self.Refresh();
            });
    };

    self.ShowConfigurationItemTypeDisplayedFieldDialog = function () {
    };

    self.RefreshDisplayedFieldGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/GetConfigurationItemTypeDisplayedFieldsCollection", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            configurationItemTypeId: parent.ConfigurationItemTypeId(),
            pageIndex: self.DisplayedFieldPageIndex(),
            pageSize: self.DisplayedFieldPageSize(),
            sorting: self.DisplayedFieldSorting()
        }), function (searchResult) {
            self.SelectedDisplayedFieldRow(null);
            self.DisplayedFieldTotalRows(0);
            self.DisplayedFieldCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.DisplayedFieldCollection(searchResult.Models);
                self.DisplayedFieldTotalRows(searchResult.TotalRows);
                self.ToggleDisplayedFieldToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };

    self.Focus = function () {
        //Dummy
    };

    //IViewModelBase Interface Member
    self.Refresh = function () {
        return self.RefreshDisplayedFieldGrid();
    };
};


function ConfigurationItemTypeViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.IsReadonly = ko.observable(false);
    self.TabViewModel = new TabViewModel(false);
    self.ConfigurationItemTypeId = ko.observable(tabPage.ObjectId());
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.ConfigurationItemType())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(self.ConfigurationItemTypeCategoryId())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.Unlock = function () {
        return Bao.post("ConfigurationItemType/UnlockConfigurationItemType", JSON.stringify({
            sessionTabId: tabPage.SessionTabId,
            configurationItemTypeId: self.ConfigurationItemTypeId()
        }));
    };
    self.BeforeClose = function (fn) {
        if (tabPage.DirtyFlag() == true && self.SaveAllowed() == true) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSaveCheck"), "question");
            questionDialog.DialogResult.subscribe(function (result) {
                if (result == true) {
                    if (self.CompleteCheck()) {
                        tabPage.IsLoading(true);
                        self.Save().done(function () {
                            self.Unlock().then(function () {
                                tabPage.IsLoading(false);
                                fn();
                            });
                        });
                    }
                }
                else if (result == false) {
                    tabPage.IsLoading(true);
                    self.Unlock().then(function () {
                        tabPage.IsLoading(false);
                        fn();
                    });
                }
            });
        }
        else {
            self.Unlock().then(fn);
        }
    };
    self.BeforeDelete = function () {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemType/IsConfigurationItemTypeInUse", JSON.stringify({
            id: self.ConfigurationItemTypeId()
        }), function (value) {
            tabPage.IsLoading(false);
            if (value != "true") {
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteConfigurationItemType"), "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.Delete();
                    }
                });
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgIsInUse"), "info");
            }
        });
    };
    self.PerformRefresh = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/GetConfigurationItemType", JSON.stringify({
            id: self.ConfigurationItemTypeId()
        }), function (value) {
            tabPage.ObjectId(value.ConfigurationItemTypeId);
            ko.map.fromJS(value, self);
            $.when(Bao.post("ConfigurationItemType/ResetConfigurationItemStatusType", JSON.stringify({
                sessionTabId: tabPage.SessionTabId
            })), Bao.post("ConfigurationItemType/ResetConfigurationItemTypeIndicator", JSON.stringify({
                sessionTabId: tabPage.SessionTabId
            })), Bao.post("ConfigurationItemType/ResetConfigurationItemTypeManufacturer", JSON.stringify({
                sessionTabId: tabPage.SessionTabId
            })), Bao.post("ConfigurationItemType/ResetConfigurationItemTypeManufacturerType", JSON.stringify({
                sessionTabId: tabPage.SessionTabId
            })), Bao.post("ConfigurationItemType/ResetConfigurationItemTypeTab", JSON.stringify({
                sessionTabId: tabPage.SessionTabId
            })),
                Bao.post("ConfigurationItemType/ResetConfigurationItemTypeDisplayedField", JSON.stringify({
                    sessionTabId: tabPage.SessionTabId
                }))).then(function () {
                    self.TabViewModel.RefreshTabs().then(function () {
                        tabPage.DirtyFlag(false);
                        tabPage.IsLoading(false);
                    });
                });
        });
    };

    self.Save = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/SaveConfigurationItemType", JSON.stringify({
            sessionTabId: tabPage.SessionTabId,
            configurationItemType: self.MinimizeEntity()
        }), function (value) {
            if (value != null) {
                if (value.Result == true) {
                    self.SaveTime(value.SaveTime);
                    self.PerformRefresh(true);
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, value.Message, "info");
                }
                tabPage.IsLoading(false);
            }
        });
    };
    self.Delete = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/DeleteConfigurationItemType", JSON.stringify({
            sessionTabId: tabPage.SessionTabId,
            configurationItemType: ko.map.toJS(self, true)
        }), function () {
            tabPage.IsLoading(false);
            AppTabController.RemoveTab(tabPage);
        });
    };
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab() == true) {
            switch (value.ActionKey()) {
                case "ConfigurationItemTypeSave":
                    if (self.CompleteCheck() == true) {
                        self.Save();
                    }
                    break;
                case "ConfigurationItemTypeRefresh":
                    self.BeforeRefresh();
                    break;
                case "ConfigurationItemTypeDelete":
                    self.BeforeDelete();
                    break;
                case "ConfigurationItemTypeUploadIcon":
                    self.UploadIcon();
                    break;
            }
        }
    }));
    self.UploadIcon = function () {
        window.baorequire(["ViewModels/Dialogs/ConfigurationItemTypeUploadIconDialog"], function (vm) {
            var dialog = new vm(tabPage, parent);
            dialog.Show(self.ConfigurationItemTypeId());
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.TabPage.DirtyFlag(true);
                }
            });
        });
    };
    var tabPageStatus = new TabPage();
    tabPageStatus.AutoSelect = true;
    tabPageStatus.Url("ConfigurationItemType/StatusTab");
    tabPageStatus.Title = Bao.Session.GetMessage("msgConfigurationItemTypeStatus");
    tabPageStatus.IsClosable(false);
    tabPageStatus.ViewModel(new ConfigurationItemTypeStatusViewModel(tabPageStatus, self));
    tabPageStatus.TabLoaded = function () {
        tabPageStatus.ViewModel().Refresh();
    };
    var tabPageConfigurationItemTypeTab = new TabPage();
    tabPageConfigurationItemTypeTab.AutoSelect = false;
    tabPageConfigurationItemTypeTab.PreLoad(false);
    tabPageConfigurationItemTypeTab.Url("ConfigurationItemType/ConfigurationItemTypeTabTab");
    tabPageConfigurationItemTypeTab.Title = Bao.Session.GetMessage("msgConfigurationItemTypeTab");
    tabPageConfigurationItemTypeTab.IsClosable(false);
    tabPageConfigurationItemTypeTab.ViewModel(new ConfigurationItemTypeTabTabViewModel(tabPageConfigurationItemTypeTab, self));
    tabPageConfigurationItemTypeTab.TabLoaded = function () {
        tabPageConfigurationItemTypeTab.ViewModel().Refresh();
    };
    var tabPageManufacturer = new TabPage();
    tabPageManufacturer.AutoSelect = false;
    tabPageManufacturer.PreLoad(false);
    tabPageManufacturer.Url("ConfigurationItemType/ManufacturerTab");
    tabPageManufacturer.Title = Bao.Session.GetMessage("msgConfigurationItemTypeManufacturer");
    tabPageManufacturer.IsClosable(false);
    tabPageManufacturer.ViewModel(new ConfigurationItemTypeManufacturerViewModel(tabPageManufacturer, self));
    tabPageManufacturer.TabLoaded = function () {
        tabPageManufacturer.ViewModel().Refresh();
    };
    var tabPageIndicator = new TabPage();
    tabPageIndicator.AutoSelect = false;
    tabPageIndicator.PreLoad(false);
    tabPageIndicator.Url("ConfigurationItemType/IndicatorTab");
    tabPageIndicator.Title = Bao.Session.GetMessage("msgConfigurationItemTypeIndicator");
    tabPageIndicator.IsClosable(false);
    tabPageIndicator.ViewModel(new ConfigurationItemTypeIndicatorViewModel(tabPageIndicator, self));
    tabPageIndicator.TabLoaded = function () {
        tabPageIndicator.ViewModel().Refresh();
    };

    var tabPageDisplayedField = new TabPage();
    tabPageDisplayedField.AutoSelect = false;
    tabPageDisplayedField.PreLoad(false);
    tabPageDisplayedField.Url("ConfigurationItemType/DisplayedFieldsTab");
    tabPageDisplayedField.Title = Bao.Session.GetMessage("msgConfigurationItemTypeDisplayedFields");
    tabPageDisplayedField.IsClosable(false);
    tabPageDisplayedField.ViewModel(new ConfigurationItemTypeDisplayedFieldViewModel(tabPageDisplayedField, self));
    tabPageDisplayedField.TabLoaded = function () {
        tabPageDisplayedField.ViewModel().Refresh();
    };

    var baseLoaded = self.loaded;
    self.loaded = function () {
        self.TabViewModel.AddTab(tabPageStatus);
        self.TabViewModel.AddTab(tabPageConfigurationItemTypeTab);
        self.TabViewModel.AddTab(tabPageManufacturer);
        self.TabViewModel.AddTab(tabPageIndicator);
        self.TabViewModel.AddTab(tabPageDisplayedField);
        if (baseLoaded != null) {
            baseLoaded.call(self);
        }
    };
    self.Focus = function () { };
    self.ConfigurationItemType = ko.observable();
    self.ConfigurationItemType1 = ko.observable();
    self.ConfigurationItemType2 = ko.observable();
    self.ConfigurationItemType3 = ko.observable();
    self.ConfigurationItemType4 = ko.observable();
    self.ConfigurationItemType5 = ko.observable();
    self.ConfigurationItemType.subscribe(function () {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.ConfigurationItemType1(self.ConfigurationItemType());
                break;
            case 2:
                self.ConfigurationItemType2(self.ConfigurationItemType());
                break;
            case 3:
                self.ConfigurationItemType3(self.ConfigurationItemType());
                break;
            case 4:
                self.ConfigurationItemType4(self.ConfigurationItemType());
                break;
            case 5:
                self.ConfigurationItemType5(self.ConfigurationItemType());
                break;
        }
    });
    self.ConfigurationItemTypeComputed = ko.computed(function () {
        self.ConfigurationItemType1();
        self.ConfigurationItemType2();
        self.ConfigurationItemType3();
        self.ConfigurationItemType4();
        self.ConfigurationItemType5();
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.ConfigurationItemType(self.ConfigurationItemType1());
                break;
            case 2:
                self.ConfigurationItemType(self.ConfigurationItemType2());
                break;
            case 3:
                self.ConfigurationItemType(self.ConfigurationItemType3());
                break;
            case 4:
                self.ConfigurationItemType(self.ConfigurationItemType4());
                break;
            case 5:
                self.ConfigurationItemType(self.ConfigurationItemType5());
                break;
        }
    });
    self.Translate = function () {
        var translateDialog = new TranslateDialogViewModel(self.ConfigurationItemType1, self.ConfigurationItemType2, self.ConfigurationItemType3, self.ConfigurationItemType4, self.ConfigurationItemType5);
        translateDialog.Open().then(function () { });
    };
}
Bao.inherit(ConfigurationItemTypeViewModel, SearchPaging);
ConfigurationItemTypeViewModel.prototype.RefreshUrl = "ConfigurationItemType/GetConfigurationItemType";
ConfigurationItemTypeViewModel.prototype.PrimaryKey = "ConfigurationItemTypeId";
ConfigurationItemTypeViewModel.prototype.PermissionForward = "ConfigurationItemTypeMoveForwardSearch";
ConfigurationItemTypeViewModel.prototype.PermissionBackward = "ConfigurationItemTypeMoveBackwardSearch";
export default ConfigurationItemTypeViewModel;